var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSIgnedDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.259 46.152C15.259 46.152 17.7158 37.162 20.1627 37.162C22.6096 37.162 25.4096 46.152 27.5181 46.152C29.6267 46.152 30.1416 42.556 32.4218 42.556C34.702 42.556 35.1874 46.152 37.3254 46.152C39.4634 46.152 44.6809 42.556 44.6809 42.556M15.259 12.1339H44.6809M15.259 20.081H44.6809M15.259 28.172H44.6809",
    stroke: "#077CA5",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5845 3H10.3555C6.29315 3 3 5.41498 3 8.394V51.546C3 54.525 6.29315 56.94 10.3555 56.94H49.5845C53.6469 56.94 56.94 54.525 56.94 51.546V8.394C56.94 5.41498 53.6469 3 49.5845 3Z",
    stroke: "#077CA5",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSIgnedDocIcon);
export default __webpack_public_path__ + "static/media/SIgnedDocIcon.8224863fdb9251ecf02f971696910abd.svg";
export { ForwardRef as ReactComponent };